module.exports = __webpack_public_path__ + "static/media/ca-x-instacart.a160f54f.svg";